import React from 'react';
import api from '../apiConnector'

import FieldYesNo from './fields/fieldYesNo';
import FieldSelect from './fields/fieldSelect';
import FieldNumeric from './fields/fieldNumeric';
import FieldDate from './fields/fieldDate';
import FieldText from './fields/fieldText';
import FormPage from './formPage';
import LegalDetails from './legalDetails';
import Vehiculier from './vehiculier';
import waiter from '../img/wait_white.svg';
import FieldCheck from './fields/fieldCheck'
import edit_button from '../img/edit.png'
import logo_permis from '../img/n de permis de conduire.svg'
import logo_immatriculation from '../img/immatriculation.png'
import logo_right from '../img/right.png'
import img_lamp from '../img/Ampoule bleu1.svg'
import img_cb from '../img/carte de crédit.svg'
import FrontSelectVehiculeAuto from './selectVehiculeAuto';
import circle_full from '../img/circle_full.png'
import {FrontEcheancierXena} from './echeancier';
import echeancier from '../img/échéancier.svg'
import arrow_down from '../img/black_arrow_down.png'
import arrow_up from '../img/black_arrow_up.png'
import logo_eco from "../img/Logo eco by assur bon plan.png"

export default class FrontDetails1 extends FormPage {
    
    constructor(props) {
        super(props);
        this.title = 'Finalisons votre dossier'
        this.state = {
            showValidate:false,
            typeAddSinistre:false,
            dateAddSinistre:false,
            resyncing:false,
            vehiculierReady:false
        }
        const isMoto = this.props.devis.type == 'moto'
        this.vehiculier = isMoto ? new Vehiculier( this.props.devis.params.marque, ()=>{this.setState({vehiculierReady:true})} ) : false
        this.nextTitle = 'Payer et valider mon contrat'
        this.contactBoxOnTop = true
    }

    componentDidMount() {
        this.componentDidUpdate()
    }

    componentDidUpdate() {
        super.componentDidUpdate()
        if ( ! this.props.devis.validated ) {
            this.props.validateDevis()
        }
        if ( this.props.devis.synchronized && this.state.resyncing ) {
            this.setState({resyncing:false})
        }
    }

    renderAnnulation(container) {
        return <>
            <FieldDate field="ant_annulation_date" container={container} />
        </>
    }

    renderStupefiants(container) {
        return <>
            <FieldDate field="ant_stupefiants_date" container={container} />
            <FieldText field="ant_stupefiants_substance" container={container} />
            <FieldSelect field="ant_stupefiants_sinistre" container={container} />
            <FieldYesNo field="ant_stupefiants_recidive" container={container} />
        </>   
    }

    renderAlcool(container) {
        return <>
            <FieldDate field="ant_alcool_date" container={container} />
            <FieldSelect field="ant_alcool_taux" container={container} />
            <FieldSelect field="ant_alcool_sinistre" container={container} />
            <FieldYesNo field="ant_alcool_recidive" container={container} />
        </>
    }

    renderRetrait(container) {
        return <>
            <FieldDate field="ant_retrait_date" container={container} />
            <FieldNumeric field="ant_retrait_duree_mois" container={container} min="0" max="36" />
            <FieldSelect field="ant_retrait_motif_full" container={container} />
            <FieldYesNo field="ant_retrait_recidive" container={container} />
        </>
    }

    renderResiliation(container) {
        return <>
            <FieldDate field="ant_resiliation_date" container={container} />
            <FieldYesNo field="ant_resiliation_non_paiement" container={container}/>
            <FieldYesNo field="ant_resiliation_fausse_declaration" container={container}/>
            <FieldYesNo field="ant_resiliation_frequence_sinistres" container={container}/>
            <FieldYesNo field="ant_resiliation_autre_motif" container={container}/>
        </>   
    }

    next() {
        const devis = this.props.devis
        if ( !devis.synchronized ) {
            if ( !this.state.resyncing ) {
                this.setState({resyncing:true})
                this.props.resync()
            }
        } else {
            this.props.setPage('payment')
//            this.props.onSubscribe()
        }
    }

    back() {
        this.props.setPage('landing')
    }

    onAddSinistre() {
        if ( this.state.typeAddSinistre && this.state.typeAddSinistre.value && this.state.dateAddSinistre ) {
            this.props.devis.addSinistre( this.state.typeAddSinistre.value, this.state.dateAddSinistre, this.props.changeParams )
        }
    }

    renderGoToAntecedents() {
        return <a className="right_anchor" onClick={()=>this.props.setPage('antecedents')}><img src={edit_button}/> Modifier la liste de vos antécédents</a>
    }

    optionsMarque() {
        return this.state.vehiculier 
            ? Object.keys( this.state.vehiculier ).map( m => ({value:m,label:m}) )
            : []
    }

    optionsModele() {
        const {marque} = this.props.devis.params
        return ( this.state.vehiculier && marque )
            ? this.state.vehiculier[marque].map( m => ({value:m,label:m}))
            : []
    }

    optionsVersions() {
        const cont = (s,pr='',p='') => ( s &&( s != '-' ) ) ? pr+s+p+' ' : ''
        return this.state.versions ? this.state.versions.map( v => 
            ({ value:v.sra, label:cont(v.version)+cont(v.generation)+cont(v.energie,'- ')+cont(v.carrosserie,'- ')+cont(v.pa,'- ',' CV') } ) ) : []
    }

    doRender(container) {
        const {devis} = this.props
        const params = devis.params
        const noticeCondSecondaire = ( params.conducteur_2 == 'O' )?<b>vous ou le conducteur secondaire</b>:'vous'
        const isMoto = devis.type == 'moto'
        const antRetrait = params.ant_retrait=='O'
        const antAnnulation = params.ant_annulation=='O'
        const antAlcool = params.ant_alcool=='O'
        const antStupefiants = params.ant_stupefiants=='O'
        const antResiliation = params.ant_resiliation=='O'
        const unsync = ! devis.synchronized

        if ( this.state.vehiculierReady &&( params.marque != this.vehiculier.getMarque() )) {
            this.vehiculier.selectMarque( params.marque )
        }


        const toPay = devis.toPay()
        const toPayYearly = devis.toPayYearly()
        this.nextTitle = 'Payer et valider mon contrat'
        if ( unsync ) {
            this.nextTitle = 'Valider'
        }
        if ( this.state.resyncing ) {
            this.nextTitle = <img src={waiter}/>
        }

        return <>
{/*
            <h2>Choisissez votre formule et votre fréquence de paiement</h2>
            <FrontTarifs container={container}/>
            <h2>Ajoutez vos options</h2>
            <FrontOptions container={container}/>
    */}
                <div className="header_offre"><img src={logo_eco}/></div>
            {this.props.devis.params.MER?<>
                <div className="contentvbox">

                <h1 className="top_title">Vérifiez le modèle de votre véhicule</h1>

                {isMoto ? <>
                    <FieldSelect field="marque" container={container} options={ this.state.vehiculierReady ? this.vehiculier.getMarques() : []}/>
                    <FieldSelect field="modele" container={container} options={ this.state.vehiculierReady ? this.vehiculier.getModeles() : []}/>
                    <FieldText field="cylindree" container={container}/>
                </>:<>
                    <FrontSelectVehiculeAuto container={container}/>
                </>}
                
                <br/>
                <a className="right_anchor" onClick={()=>this.props.setPage('vehicule')}><img src={edit_button}/> Vérifier l'ensemble des infos véhicule</a>

                </div>
                <div className="contentvbox">

                <h1 className="top_title">Quelques dernières précisions</h1>

{/*                <FieldYesNo field="ne_en_france" container={container} />
                {(params.ne_en_france=='O')
                    ? <><FieldText field="commune_naissance" container={container} />
                    <i>Sans code postal. Exemple: Paris</i>
                    </> : ''}
                {(params.ne_en_france=='N')
                    ? <FieldSelect field="pays_naissance" container={container} />
            : ''} */}

                <FieldText field="commune_naissance" placeholder="Sans code postal. Exemple: Paris" label="Commune de naissance (si vous êtes né en France)" container={container} />
                <FieldSelect field="pays_naissance" label="Pays de naissance (si vous êtes né à l'étranger)" container={container}/>

                <FieldSelect field="situation_famille" container={container} />
                <FieldNumeric field="nombre_enfants" container={container} min="0" max="16" />
                {isMoto?<>
                    <FieldYesNo field="assur_23_mois" container={container}  />
                    <LegalDetails container={container} />
                </>:<>
                    <FieldYesNo field="cac" container={container}  />
                    <FieldYesNo field="assure_actuellement" container={container} label="Vous êtes assuré actuellement pour une auto"/>
                    {(params.assure_actuellement=='O')?<>
                        <FieldSelect field="antecedant_assur" container={container}  />
                    </>:<>
                        <FieldSelect field="antecedant_non_assur" container={container}  />
                    </>}

                    {(params.conducteur_2!='O')?<></>:<>
                        <FieldText field="nom_2" container={container}/>
                        <FieldText field="prenom_2" container={container}/>
                        <h3> Le conducteur secondaire est votre conjoint(e)/concubin(e)</h3>
                    </>
                    }
                    <a className="right_anchor" onClick={()=>this.props.setPage('vous')}><img src={edit_button}/> Vérifier l'ensemble des infos préremplies</a>
                    
                </>}

                {antRetrait?<>
                    <h3><span>Retraits de permis</span></h3>
                    {this.renderGoToAntecedents()}
                    <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet d'un retrait de permis</label>
                    {( params.ant_retrait=='O' )? this.renderRetrait(container) : '' }
                </>:<></>}

                {antAnnulation?<>
                    <h3><span>Annulation de permis</span></h3>
                    <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet d'une annulation de permis</label>
                    {( params.ant_annulation=='O' )? this.renderAnnulation(container) : '' }
                </>:<></>}

                {antAlcool?<>
                    <h3><span>Alcoolémie</span></h3>
                    <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet d'une sanction en état d'ébriété</label>
                    {( params.ant_alcool=='O' )? this.renderAlcool(container) : '' }
                </>:<></>}

                {antStupefiants?<>
                    <h3><span>Stupéfiants</span></h3>
                    <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet de poursuites ou condamnations pour conduite sous l'emprise de stupéfiants, drogues ou médicaments non prescrits</label>
                    {( params.ant_stupefiants=='O' )? this.renderStupefiants(container) : '' }
                </>:<></>}

                {antResiliation?<>
                    <h3><span>Résiliation d'assurance</span></h3>
                    <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet d'une résiliation par un précédent assureur</label>
                    <i>(Pour un motif autre que alcoolémie, stupéfiants, annulation ou retrait de permis)</i>
                    {( params.ant_resiliation=='O' )? this.renderResiliation(container) : '' }
                </>:<></>}

                {(!(antRetrait||antAlcool||antAnnulation||antResiliation||antStupefiants))
                ? <><h2>{noticeCondSecondaire} n'avez déclaré aucun antécédent (retrait, annulation de permis, sanctions sous emprise de l'alcool ou de stupéfiants, résiliations, ...)</h2>
                </>
                :''}
                {this.renderGoToAntecedents()}
                </div>
            </>:''}
            
            <div className="contentvbox">

            <h1 className="top_title">Souscription</h1>

            <FieldYesNo field="hamon_deja_assure" container={container} />
            {( params.hamon_deja_assure == 'O' )?
                <FieldYesNo field="hamon_assure_au_moins_12_mois" container={container} />:''}
            {(( params.hamon_deja_assure == 'O' )&&( params.hamon_assure_au_moins_12_mois == 'O' ))?
                <FieldYesNo field="hamon_resiliation_necessaire" container={container} />:''}
            {(( params.hamon_deja_assure == 'O' )&&( params.hamon_assure_au_moins_12_mois == 'O' )&&( params.hamon_resiliation_necessaire == 'O' ))?
                <FieldYesNo field="hamon_resiliation_envoyee" container={container} />:''}
            {devis.hamonApplies()
            ? <p><span className="notice">La loi Hamon nous oblige à faire la demande de résiliation auprès de votre ancien assureur.
                <br/><u>Votre contrat avec nous ne prendra effet qu'une fois la résiliation effective.</u>
            </span></p>
            : <FieldDate field="date_effet" container={container} />}
            
            <FieldText field="numero_permis" container={container} noCheck={unsync} logo={logo_permis}/>
            <FieldText field="immatriculation" container={container} noCheck={unsync} logo={logo_immatriculation} logoClass="immatriculation"/>

            <div className="notice_box">
                <div className="img_box"><img src={img_lamp}/></div>
                <div className="text_box">
                    <h3>Le numéro d'immatriculation se trouve dans la section A de votre carte grise !</h3>
                    Pour un véhicule neuf, vous pouvez indiquer le numéro d'immatriculation provisoire. 
                    <b> N'oubliez pas de nous fournir le numéro définitif dès que vous l'obtenez.</b>
                </div>
            </div>
{/*
            <FieldText field="numero_serie" 
                container={container} 
                logo={logo_permis}
                placeholder="Les 7 derniers caractères de la section E de votre carte grise."
                notice={<u>Laissez ce champ vide si vous ne connaissez pas votre numéro de série.</u>} 
                noCheck={unsync}/>
*/}         
            <FieldYesNo field="assure_30_derniers_jours" container={container} />

            <FieldText field="iban" 
                logo={logo_right}
                container={container} 
                placeholder="27 caractères commençant par FR"
                noCheck={unsync}/>


            <div className="notice_box">
                <div className="img_box"><img src={img_cb}/></div>
                <div className="text_box">
                    <p>
                    Dès la validation du paiement, le montant de <b>{this.props.devis.toPay()} € </b>
                    { ( params.periodicite == 'M' )?<>
                        qui correspond à vos <strong>deux premières mensualités</strong> sera débité
                        de votre carte bancaire.
                    </>:<>
                        qui correspond à <strong>votre première année de cotisation</strong> sera débité
                        de votre carte bancaire.
                    </> }
                    </p>
                    <p>
                    Puis un justificatif d'assurance vous sera envoyé. Votre véhicule
                    sera ensuite inscrit dans le <strong>Fichier des Véhicules Assurés (FVA) </strong>
                    sous <b>72 heures.</b>
                    </p>
                </div>
            </div>

            <FieldCheck field="own_iban" container={container} noCheck={unsync} disabled={!devis.getValue('iban','').trim()}/>
            <FieldCheck field="accept_cgu" container={container}/>

            { this.props.embeded
            ? <FieldSelect 
                    field="frais_sup" container={container} options={devis.getOptionsFraisSup(api.isAdmin())} 
                    label={<>Les frais de base pour ce type de véhicule sont de <b>{devis.params.frais} €</b>.<br/>Vous pouvez appliquer des frais supplémentaires, dans la limite de {devis.max_frais} € de frais totaux :</>}
                /> : ''}


            { unsync
            ? <p>Vos informations ont changé. Cliquez sur "Valider" pour régénérer le devis.</p> 
            : <><div className="standalone_prices notice_box">
                    <div className="img_box"><img src={img_cb}/></div>
                    <div className="text_box">
                    {(params.periodicite=='M')?<>
                        <div className="price_row"><b>{devis.toPayMonthly()}</b> par mois</div>
                        <div className="price_row"><b>{devis.toPayYearly()}</b> par an TTC*</div>
                    </>:<>
                        <div className="price_row"><b>{devis.toPayYearly()}</b> par an TTC*</div>
                    </>}
                    <p>* Frais de gestion et courtage inclus.<br/>
                    {(params.periodicite=='M')?<>
                    L'acompte de <b>{devis.toPay()} €</b> inclut les frais de gestion et de
                    courtage ainsi que les deux premiers mois. Puis, par mois, à
                    partir du 3ème mois : <b>{devis.toPayMonthly()} €</b></>:<></>}
                    </p>
                    </div>
                </div>
                <div>
                    <h2 className="clickbox"
                        onClick={()=>this.setState(state=>({collapseEcheancier:!state.collapseEcheancier}))}
                    >
                        <img src={echeancier}/> 
                        Votre <b>échéancier</b>
                        <img className="right_switch" src={this.state.collapseEcheancier ? arrow_down : arrow_up}/>
                    </h2>

                    <FrontEcheancierXena container={container} hidden={this.state.collapseEcheancier}/>
                
                </div>
            </> }
            </div>

        </>
    }
}

FrontDetails1.optionsTypeSinistre = [
    { value:'nr',label:'Non responsable' },
    { value:'vi',label:'Vol, incendie' },
    { value:'mr',label:'Matériel responsable' },
    { value:'cr',label:'Corporel responsable' }
]